/* Libraries */
import Vue from "vue";
import VueRouter from "vue-router";
/* Libraries */

import store from "@/store";

//signal
import Signal from "./imports/signal";
const { AllSignals } = Signal;

//info
import Info from "./imports/info";
const { BankInformation } = Info;
const { AddBankAccount } = Info;
const { AddCryptoAccount } = Info;
const { AddOthersAccount } = Info;

//profit
import Profit from "./imports/profit";
const { ProfitLossChart } = Profit;

//dashboard
import Dashboard from "./imports/dashboard";
const { DashboardView } = Dashboard;

//faq
import Faq from "./imports/faq";
const { FaqView } = Faq;

//trade
import Trades from "./imports/trades";
const { CloseTrade, CloseTradeDetails, LiveTrade, LiveTradeDetails } = Trades;

//mt5
import Mt5 from "./imports/mt5";
const { Mt5View, Mt5Details, ChangeMt5Password } = Mt5;

//leverage
import Leverage from "./imports/leverage";
const { ChangeLeverage } = Leverage;
import TermsAndCondition from "@/views/TermsAndCondition.vue";

//account
import Account from "./imports/account";
const {
  MyInvestorAccount,
  MyInvestorAccountDetails,
  CreateAccount,
  CreateDemoAccount,
  CreateInvestorAccount,
  CreateInvestorAccountDetails,
  CreateInvestorAccountSuccess,
  CreateLiveAccount,
  CreateManagerAccount,
  DemoAccount,
  DemoAccountDetails,
  LiveAccount,
  LiveAccountDetails,
  ManageInvestorsAccount,
  ManageInvestorsAccountDetails,
} = Account;

//platform
import Platform from "./imports/platform";
const { PlatformView } = Platform;

//profile
import Profile from "./imports/profile";
const { ProfileAndVerification } = Profile;

//auth
import Auth from "./imports/auth";
const {
  Registration,
  LoginView,
  CreateInvestorAccountAuth,
  ChangePassword,
  ForgotPassword,
} = Auth;

//support
import Support from "./imports/support";
const { SupportView } = Support;

//transaction
import Transaction from "./imports/transaction";
const { TransactionHistory } = Transaction;

//otp
import Otp from "./imports/otp";
const { SendOtp } = Otp;

// Wallet
import Wallet from "./imports/wallet";
const {
  WalletView,
  // deposit
  DepositView,
  BankDepositForm,
  CashDepositForm,
  CryptoDepositForm,
  // withdraw
  WithdrawView,
  CashWithdrawForm,
  CashWithdrawFormOtp,
  BankWithdrawForm,
  BankWithdrawFormOtp,
  CryptoWithdrawForm,
  CryptoWithdrawFormOtp,
  //internal transfer
  InternalTransferForm,
} = Wallet;

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

function checkUserAuthentication() {
  const token = store.state.authentication.token;

  if (token) {
    const decodedToken = decodeJwt(token);

    if (
      decodedToken &&
      new Date(decodedToken.exp * 1000) > new Date() &&
      new Date(decodedToken.exp * 1000) <
      new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
    ) {
      return true;
    }
  }

  return false;
}

function decodeJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    const payload = JSON.parse(atob(base64));
    return payload;
  } catch (error) {
    return null;
  }
}

const routes = [
  {
    path: "/",
    name: "/",
    component: LoginView,
    meta: {
      noSidebar: true,
      title: "Login",
    },
  },

  {
    path: "/dashboard",
    component: DashboardView,
    name: "DashboardView",
    meta: { requiresAuth: true, title: "Dashboard" },
  },
  {
    path: "/create-account",
    component: CreateAccount,
    name: "CreateAccount",
    meta: {
      noSidebar: true,
      title: "Create Account",
    },
  },
  {
    path: "/registration",
    component: Registration,
    name: "Registration",
    meta: {
      noSidebar: true,
      title: "Registration",
    },
    // beforeEnter: (to, from, next) => {
    //   if (store.state.authentication.registerInfo.email === null) {
    //     next("/create-account");
    //   } else if (store.state.authentication.registerInfo.email !== null) {
    //     next("/dashboard");
    //   } else {
    //     next();
    //   }
    // },
  },
  {
    path: "/send-otp",
    component: SendOtp,
    name: "SendOtp",
    meta: {
      noSidebar: true,
      title: "Send Otp",
    },
    // beforeEnter: (to, from, next) => {
    //   if (store.state.authentication.registerInfo.email === null) {
    //     next("/create-account");
    //   } else if (store.state.authentication.registerInfo.email !== null) {
    //     next("/dashboard");
    //   } else {
    //     next();
    //   }
    // },
  },
  {
    path: "/trading-details",
    name: "LiveTrade",
    component: LiveTrade,
    meta: { requiresAuth: true, title: "Trading details" },
  },
  {
    path: "/live-trade-details",
    name: "LiveTradeDetails",
    component: LiveTradeDetails,
    meta: { requiresAuth: true, title: "Live Trade Details" },
  },
  {
    path: "/profit-loss-chart",
    name: "ProfitLossChart",
    component: ProfitLossChart,
    meta: { requiresAuth: true, title: "Profit Loss Chart" },
  },
  {
    path: "/transaction-history",
    name: "TransactionHistory",
    component: TransactionHistory,
    meta: { requiresAuth: true, title: "Transaction History" },
  },
  {
    path: "/close-trade",
    name: "CloseTrade",
    component: CloseTrade,
    meta: { requiresAuth: true, title: "Close Trade" },
  },
  {
    path: "/change-leverage",
    name: "ChangeLeverage",
    component: ChangeLeverage,
    meta: { requiresAuth: true, title: "Change Leverage" },
  },
  {
    path: "/close-trade-details",
    name: "CloseTradeDetails",
    component: CloseTradeDetails,
    meta: { requiresAuth: true, title: "Close Trade Details" },
  },
  {
    path: "/wallet",
    name: "WalletView",
    component: WalletView,
    meta: { requiresAuth: true, title: "Wallet" },
  },
  //withdraw
  {
    path: "/withdraw",
    name: "WithdrawView",
    component: WithdrawView,
    meta: { requiresAuth: true, title: "Withdraw" },
  },
  {
    path: "/cash-withdraw",
    name: "CashWithdrawForm",
    component: CashWithdrawForm,
    meta: { requiresAuth: true, title: "Cash Withdraw" },
  },
  {
    path: "/cash-withdraw-otp",
    name: "CashWithdrawFormOtp",
    component: CashWithdrawFormOtp,
    meta: { requiresAuth: true, title: "Cash Withdraw OTP" },
  },
  {
    path: "/bank-withdraw",
    name: "BankWithdrawForm",
    component: BankWithdrawForm,
    meta: { requiresAuth: true, title: "Bank Withdraw" },
  },
  {
    path: "/bank-withdraw-otp",
    name: "BankWithdrawFormOtp",
    component: BankWithdrawFormOtp,
    meta: { requiresAuth: true, title: "Bank Withdraw OTP" },
  },
  {
    path: "/crypto-withdraw",
    name: "CryptoWithdrawForm",
    component: CryptoWithdrawForm,
    meta: { requiresAuth: true, title: "Crypto Withdraw" },
  },
  {
    path: "/crypto-withdraw-otp",
    name: "CryptoWithdrawFormOtp",
    component: CryptoWithdrawFormOtp,
    meta: { requiresAuth: true, title: "Crypto Withdraw OTP" },
  },
  //deposit
  {
    path: "/deposit",
    name: "DepositView",
    component: DepositView,
    meta: { requiresAuth: true, title: "Deposit" },
  },
  {
    path: "/cash-deposit",
    name: "CashDepositForm",
    component: CashDepositForm,
    meta: { requiresAuth: true, title: "Cash Deposit" },
  },
  {
    path: "/bank-deposit",
    name: "BankDepositForm",
    component: BankDepositForm,
    meta: { requiresAuth: true, title: "Bank Deposit" },
  },
  {
    path: "/crypto-deposit",
    name: "CryptoDepositForm",
    component: CryptoDepositForm,
    meta: { requiresAuth: true, title: "Crypto Deposit" },
  },
  //internal transfer
  {
    path: "/internal-transfer",
    name: "InternalTransferForm",
    component: InternalTransferForm,
    meta: { requiresAuth: true, title: "Internal Transfer" },
  },
  {
    path: "/bank-information",
    name: "BankInformation",
    component: BankInformation,
    meta: { requiresAuth: true, title: "Bank Information" },
  },
  {
    path: "/add-bank-account",
    name: "AddBankAccount",
    component: AddBankAccount,
    meta: { requiresAuth: true, title: "Add Bank Account" },
  },
  {
    path: "/add-crypto-account",
    name: "AddCryptoAccount",
    component: AddCryptoAccount,
    meta: { requiresAuth: true, title: "Add Crypto Account" },
  },
  {
    path: "/add-others-account",
    name: "AddOthersAccount",
    component: AddOthersAccount,
    meta: { requiresAuth: true, title: "Add Others Account" },
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    meta: { requiresAuth: true, title: "Change Password" },
  },
  {
    path: "/profile-verify",
    name: "ProfileAndVerification",
    component: ProfileAndVerification,
    meta: { requiresAuth: true, title: "Profile and Verification" },
  },
  {
    path: "/mt5-accounts",
    name: "Mt5View",
    component: Mt5View,
    meta: { requiresAuth: true, title: "My Accounts" },
  },
  {
    path: "/trading-account-details",
    name: "Mt5Details",
    component: Mt5Details,
    meta: { requiresAuth: true, title: "Account Details" },
  },
  {
    path: "/change-mt5-password",
    name: "ChangeMt5Password",
    component: ChangeMt5Password,
    meta: { requiresAuth: true, title: "Change MT5 Password" },
  },
  {
    path: "/live-account",
    name: "LiveAccount",
    component: LiveAccount,
    meta: { requiresAuth: true, title: "Live Account" },
  },
  {
    path: "/live-account-details",
    name: "LiveAccountDetails",
    component: LiveAccountDetails,
    meta: { requiresAuth: true, title: "Live Account Details" },
  },
  {
    path: "/my-investor-account",
    name: "MyInvestorAccount",
    component: MyInvestorAccount,
    meta: { requiresAuth: true, title: "My Investor Account" },
  },
  {
    path: "/my-investor-account-details",
    name: "MyInvestorAccountDetails",
    component: MyInvestorAccountDetails,
    meta: { requiresAuth: true, title: "My Investor Account Details" },
  },
  {
    path: "/manage-investors-account",
    name: "ManageInvestorsAccount",
    component: ManageInvestorsAccount,
    meta: { requiresAuth: true, title: "My Manager Account" },
  },
  {
    path: "/manage-investors-account-details",
    name: "ManageInvestorsAccountDetails",
    component: ManageInvestorsAccountDetails,
    meta: { requiresAuth: true, title: "My Manager Account Details" },
  },
  {
    path: "/forget-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      noSidebar: true,
      title: "Forgot Password",
    },
  },
  {
    path: "/demo-account",
    name: "DemoAccount",
    component: DemoAccount,
    meta: { requiresAuth: true, title: "Demo Account" },
  },
  {
    path: "/demo-account-details",
    name: "DemoAccountDetails",
    component: DemoAccountDetails,
    meta: { requiresAuth: true, title: "Demo Account Details" },
  },
  {
    path: "/create-live-account",
    name: "CreateLiveAccount",
    component: CreateLiveAccount,
    meta: { requiresAuth: true, title: "Create Live Account" },
  },
  {
    path: "/create-demo-account",
    name: "CreateDemoAccount",
    component: CreateDemoAccount,
    meta: { requiresAuth: true, title: "Create Demo Account" },
  },
  {
    path: "/create-investor-account",
    name: "CreateInvestorAccount",
    component: CreateInvestorAccount,
    meta: { requiresAuth: true, title: "Create Investor Account" },
  },
  {
    path: "/create-manager-account",
    name: "CreateManagerAccount",
    component: CreateManagerAccount,
    meta: { requiresAuth: true, title: "Create Manager Account" },
  },
  {
    path: "/create-investor-account-auth",
    name: "CreateInvestorAccountAuth",
    component: CreateInvestorAccountAuth,
    meta: { requiresAuth: true, title: "Create Investor Account Auth" },
  },
  {
    path: "/create-investor-account-success",
    name: "CreateInvestorAccountSuccess",
    component: CreateInvestorAccountSuccess,
    meta: { requiresAuth: true, title: "Create Investor Account Success" },
  },
  {
    path: "/manager-details",
    name: "CreateInvestorAccountDetails",
    component: CreateInvestorAccountDetails,
    meta: { requiresAuth: true, title: "Create Investor Account Details" },
  },
  {
    path: "/support",
    name: "SupportView",
    component: SupportView,
    meta: { requiresAuth: true, title: "Support" },
  },
  {
    path: "/faq",
    name: "FaqView",
    component: FaqView,
    meta: { requiresAuth: true, title: "Faq" },
  },
  {
    path: "/platform",
    name: "PlatformView",
    component: PlatformView,
    meta: { requiresAuth: true, title: "Platform" },
  },
  {
    path: "/terms-and-condition",
    name: "TermsAndCondition",
    component: TermsAndCondition,
    meta: { requiresAuth: true, title: "Platform" },
  },
  {
    path: "/all-signals",
    name: "AllSignals",
    component: AllSignals,
    meta: { requiresAuth: true, title: "All Signals" },
  },
  {
    path: "*",
    redirect: () => {
      const isAuthenticated = checkUserAuthentication();
      if (isAuthenticated) {
        return "/dashboard";
      } else {
        return "/";
      }
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

router.beforeEach((to, from, next) => {
  const companyInfo = router.app.$store.state.company.generalInfo;
  const companyName = companyInfo ? companyInfo.company_name : null;
  document.title = `${to.meta.title} ${companyName ? `| ${companyName}` : ""}`;

  const isAuthenticated = checkUserAuthentication();

  if (isAuthenticated) {
    if (to.path === "/") {
      next("/dashboard");
    } else {
      next();
    }
  } else {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      next("/");
    } else {
      next();
    }
  }
});

export default router;
